//add
export const dialogAdd = { DialogTitle:"Inserisci nuovo dispositivo" }
export const dialogAddUser = { DialogTitle: "Inserisci nuovo utente" }

//Edit
export const dialogEdit = { DialogTitle:"Modifica dispositivo"   }
export const dialogEditUser = { DialogTitle: "Modifica utente" }

//Cambio Password
export const dialogCambioPassword = { DialogTitle: "Cambio password" }


//Function tag
export const changeStatusDeviceDialog = (statoDispositivo) => {
     const textStatoDispositivo = statoDispositivo === true ? "Disabilitare" : "Abilitare";
    return textStatoDispositivo;
} 

export const changeStatusDeviceTitleDialog = (statoDispositivo ) => {
    const textStatoDispositivo = statoDispositivo === true ? "Disabilita" : "Abilita";
   return `${textStatoDispositivo} dispositivo`
} 

export const changeStatusUserDialog = (userState) => {
    const textUserState = userState === true ? "Abilitare" : "Disabilitare";
    return textUserState;
} 

export const changeStatusUserTitleDialog = (userState) => {
   const textUserState = userState === true ? "Abilita" : "Disabilita";
    return `${textUserState} utente`;
} 


//Generic
export const dialogButtonGeneral = { Confirm:"Salva", Cancel:"Annulla" }

export const dialogButtonConfirm = { Confirm:"Conferma", Cancel:"Annulla" }
